import type { PropsWithChildren } from 'react';
import { createContext, useContext, useState } from 'react';

const HasStoreBannerContext = createContext<{
  hasStoreBanner: boolean;
  setHasStoreBanner: (hasStoreBanner: boolean) => void;
}>({ hasStoreBanner: false, setHasStoreBanner: () => {} });

export function HasStoreBannerProvider({ children }: PropsWithChildren) {
  const [hasStoreBanner, setHasStoreBanner] = useState(false);

  return (
    <HasStoreBannerContext.Provider
      value={{ hasStoreBanner, setHasStoreBanner }}
    >
      {children}
    </HasStoreBannerContext.Provider>
  );
}

export const useHasStoreBanner = () => useContext(HasStoreBannerContext);
